<form  [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate="USER.NAPOMENA.SINGULAR"></span></h2>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
    <div class="col-md-12">
      <yt-text-area
        [MaxLength]="2000"
        name="txtNapomena"
        formControlName="Napomena"
        Height="5"
        [Label]="'USER.NAPOMENA.SINGULAR'">
      </yt-text-area>
    </div>
  </div>
<div class="modal-footer">
  <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()"><span>Sačuvaj</span></button>
  <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Zatvori</span></button>
</div>
</form>
